import { createClient } from '@/lib/contentful/initContentful';
import { IIdea } from '@/@types/generated/contentful';

const client = createClient();

export async function fetchIdeasEntries() {
  let ideaList: IIdea[] = [];
  await client
    .getEntries({
      content_type: 'idea',
      order: 'fields.id'
    })
    .then((doc) => {
      ideaList = (doc.items as IIdea[]).filter((item) => item);
    })
    .catch((error) => {
      throw new Error(error);
    });
  return ideaList;
}

export async function fetchNewIdeasEntries(limit: number) {
  let ideaList: IIdea[] = [];
  await client
    .getEntries({
      content_type: 'idea',
      order: '-fields.id',
      limit: limit || 4
    })
    .then((doc) => {
      ideaList = (doc.items as IIdea[]).filter((item) => item);
    })
    .catch((error) => {
      throw new Error(error);
    });
  return ideaList;
}

export async function fetchFavoritedIdeasEntries(favoritedList: string[]) {
  const result: IIdea[] = await Promise.all(
    favoritedList.map((item) => {
      return client
        .getEntries({
          content_type: 'idea',
          'fields.id': item,
          order: 'fields.id'
        })
        .then((doc) => {
          return doc.items[0] as IIdea;
        })
        .catch((error) => {
          throw new Error(error);
        });
    })
  );
  const ideaList = result.filter((item) => item);
  return ideaList;
}

export async function fetchIdeaEntry(slug: string) {
  let idea: IIdea | null = null;
  await client
    .getEntries({
      content_type: 'idea',
      'fields.slug': slug,
      order: 'fields.id'
    })
    .then((doc) => {
      idea = doc.items[0] as IIdea;
    })
    .catch((error) => {
      throw new Error(error);
    });
  return idea;
}
